var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('password-change-form',{ref:"form",attrs:{"title":"Password change","buttonText":"Save changes"},on:{"save":function($event){return _vm.onPasswordSave($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }